import React, {useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toast} from 'react-toastify';
import {useFormik} from 'formik';
import {loginUser} from '@store/reducers/auth';
import * as Yup from 'yup';
import {Form, Input, Button, Alert, ConfigProvider} from 'antd';
import './Login.scss';

const Login = () => {
    const [isAuthLoading, setAuthLoading] = useState(false);
    const dispatch = useDispatch();
    const errorLogin = useSelector((state) => state.auth.errorLogin);

    const login = async (username, password) => {
        try {
            setAuthLoading(true);
            const model = {
                username: username,
                password: password
            };
            const resultAction = await dispatch(loginUser(model));
            setAuthLoading(false);
            if (loginUser.fulfilled.match(resultAction) && resultAction.payload?.accessToken) {
                window.location.reload();
            }
        } catch (error) {
            setAuthLoading(false);
            toast.error('Đã có lỗi xảy ra, vui lòng thử lại !');
        }
    };

    const formik = useFormik({
        initialValues: {
            username: '',
            password: ''
        },
        validationSchema: Yup.object({
            username: Yup.string()
                .required('Tài khoản không được trống'),
            password: Yup.string()
                .min(6, 'Độ dài tối thiểu 6 ký tự')
                .max(30, 'Độ dài không vượt quá 30 ký tự')
                .required('Mật khẩu không được trống')
        }),
        onSubmit: (values) => {
            login(values.username, values.password);
        }
    });

    document.getElementById('root').classList = 'hold-transition';

    return (
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#2c8a7c',
                },
            }}
        >
            <div className="login-page-container">
                <div className="login-logo-badge">
                    <img src="/img/logo.png" alt="Logo Bệnh viện 108" />
                </div>
                
                <div className="login-card">
                    <h1 className="login-title">
                        Hệ thống quản lý<br/> Thông tin khoa học
                    </h1>
                    <div className="login-subtitle">
                        Vui lòng đăng nhập tài khoản để sử dụng hệ thống
                    </div>

                    {errorLogin && (
                        <Alert
                            message={errorLogin}
                            type="error"
                            showIcon
                            style={{marginBottom: 20}}
                        />
                    )}

                    <Form
                        layout="vertical"
                        onFinish={formik.handleSubmit}
                        requiredMark={false}
                    >
                        <Form.Item
                            label="Tài khoản"
                            validateStatus={formik.touched.username && formik.errors.username ? 'error' : ''}
                            help={formik.touched.username && formik.errors.username}
                        >
                            <Input
                                size="large"
                                placeholder="Nhập tài khoản"
                                name="username"
                                value={formik.values.username}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Item>

                        <Form.Item
                            label="Mật khẩu"
                            validateStatus={formik.touched.password && formik.errors.password ? 'error' : ''}
                            help={formik.touched.password && formik.errors.password}
                            style={{marginBottom: 28}}
                        >
                            <Input.Password
                                size="large"
                                placeholder="••••••••"
                                name="password"
                                value={formik.values.password}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                            />
                        </Form.Item>

                        <Form.Item style={{marginBottom: 0}}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                block
                                loading={isAuthLoading}
                                className="login-btn-submit"
                            >
                                ĐĂNG NHẬP
                            </Button>
                        </Form.Item>
                    </Form>
                </div>
            </div>
        </ConfigProvider>
    );
};

export default Login;

